var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionRelease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.694,
    height: 14.083,
    viewBox: "0 0 13.694 14.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 -3.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5 3.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#feac29",
    width: 3.317,
    height: 6.016,
    transform: "translate(0 4.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#feac29",
    width: 3.317,
    height: 10.042,
    transform: "translate(4.222 2.02)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feac29",
    d: "M0,0H5.25V14.083H0Z",
    transform: "translate(8.444 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionRelease);
export default __webpack_public_path__ + "static/media/versionRelease.c02880c8.svg";
export { ForwardRef as ReactComponent };